<script>
export default {
  name: 'Banner',
  props: ['bannerImage'],
  methods: {
    getImgUrl(pet) {
      var images = require.context('../assets/', false, /\.jpg$/)
      return images('./' + pet + ".jpg")
    }
  },
}
</script>


<template>
  <div class="banner">
    <img :src="getImgUrl(bannerImage)" >
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.banner{
  min-height: 110px;
  max-height: 110px;
  border-bottom: 1px solid $black-light;
  overflow: hidden;
  display: flex;
  align-items: center;
  z-index: 1;

  & img{
    width: 100%;
  }
}

</style>
